webpackJsonp([114276838955818,60335399758886],{

/***/ 88:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(177);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(88);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/credit-application.4fb880a7.pdf";

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lessor-datasheet.77854c97.pdf";

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _creditApplication = __webpack_require__(307);
	
	var _creditApplication2 = _interopRequireDefault(_creditApplication);
	
	var _lessorDatasheet = __webpack_require__(308);
	
	var _lessorDatasheet2 = _interopRequireDefault(_lessorDatasheet);
	
	__webpack_require__(275);
	
	__webpack_require__(274);
	
	__webpack_require__(273);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'header' },
	    _react2.default.createElement(
	      'div',
	      { className: 'logo' },
	      _react2.default.createElement('i', { className: 'fa fa-globe', 'aria-hidden': 'true' }),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'logo-link', to: '/' },
	        ' Leasing Solutions LLC'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'nav' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'header-link', to: '/services' },
	        'Services'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'header-link', to: '/experience' },
	        'Experience'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'header-link', to: '/why' },
	        'Why Lease'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'header-link', to: '/links' },
	        'Links'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'header-link', to: '/contact' },
	        'Contact'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'forms-wrap' },
	        _react2.default.createElement(
	          'form',
	          { className: 'download-btn-form', method: 'get', action: _lessorDatasheet2.default },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'download-btn' },
	            'Lessor Datasheet'
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'download-btn-form', method: 'get', action: _creditApplication2.default },
	          _react2.default.createElement(
	            'button',
	            { type: 'submit', className: 'download-btn' },
	            'Credit Application'
	          )
	        )
	      )
	    )
	  );
	};
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'section-wrap' },
	      _react2.default.createElement(
	        'div',
	        { className: 'left' },
	        _react2.default.createElement(
	          'div',
	          { className: 'company-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'name' },
	            '\xA9 Leasing Solutions LLC. All Rights Reserved.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'address' },
	            '755 Route 340 Palisades, New York'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'contact-info' },
	            _react2.default.createElement(
	              'div',
	              { className: 'contact-info-desktop' },
	              _react2.default.createElement(
	                'a',
	                { className: 'contact-link', href: 'tel:+1-845-362-6106' },
	                '845.362.6106'
	              ),
	              ' | ',
	              _react2.default.createElement(
	                'a',
	                { className: 'contact-link', href: 'mailto:sgeller@leasingsolutionsllc.com' },
	                'sgeller@leasingsolutionsllc.com'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'contact-info-mobile' },
	              _react2.default.createElement(
	                'a',
	                { className: 'contact-link', href: 'tel:+1-845-362-6106' },
	                '845.362.6106'
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'contact-link', href: 'mailto:sgeller@leasingsolutionsllc.com' },
	                'sgeller@leasingsolutionsllc.com'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'right' },
	        _react2.default.createElement(
	          'div',
	          { className: 'nav' },
	          _react2.default.createElement(
	            'span',
	            { className: 'links-wrap' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'footer-link', to: '/experience' },
	              'About'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'footer-link', to: '/contact' },
	              'Contact'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'footer-link', to: '/services' },
	              'Services'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'footer-link', to: '/sitemap' },
	              'Sitemap'
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { className: 'get-funding-form', method: 'get', action: _creditApplication2.default },
	            _react2.default.createElement(
	              'button',
	              { type: 'submit', className: 'get-funding' },
	              'Get Me Funding'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'app' },
	    _react2.default.createElement(Header, null),
	    children(),
	    _react2.default.createElement(Footer, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-0ba6a801652a074bae4b.js